var map = {
	"./": [
		22578,
		729,
		815,
		954
	],
	"./Dashboard": [
		7815,
		729,
		815,
		619
	],
	"./Dashboard.vue": [
		7815,
		729,
		815,
		619
	],
	"./account": [
		54450
	],
	"./account/": [
		54450
	],
	"./account/Layout": [
		85267
	],
	"./account/Layout.vue": [
		85267
	],
	"./account/Login": [
		47442
	],
	"./account/Login.vue": [
		47442
	],
	"./account/index": [
		54450
	],
	"./account/index.js": [
		54450
	],
	"./bond": [
		90522
	],
	"./bond/": [
		90522
	],
	"./bond/BondInterestHistory": [
		47062
	],
	"./bond/BondInterestHistory.vue": [
		47062
	],
	"./bond/BondLIst": [
		57527
	],
	"./bond/BondLIst.vue": [
		57527
	],
	"./bond/Layout": [
		46510
	],
	"./bond/Layout.vue": [
		46510
	],
	"./bond/index": [
		90522
	],
	"./bond/index.js": [
		90522
	],
	"./configuration": [
		9855
	],
	"./configuration/": [
		9855
	],
	"./configuration/Layout": [
		77004
	],
	"./configuration/Layout.vue": [
		77004
	],
	"./configuration/Summary": [
		58201
	],
	"./configuration/Summary.vue": [
		58201
	],
	"./configuration/index": [
		9855
	],
	"./configuration/index.js": [
		9855
	],
	"./dashboard/summary/StatisticsChart": [
		30729,
		729,
		387
	],
	"./dashboard/summary/StatisticsChart.vue": [
		30729,
		729,
		387
	],
	"./dashboard/summary/StockId": [
		30004,
		4
	],
	"./dashboard/summary/StockId.vue": [
		30004,
		4
	],
	"./docs": [
		47884,
		36,
		248
	],
	"./docs/": [
		47884,
		36,
		248
	],
	"./docs/Documentation": [
		35036,
		36,
		327
	],
	"./docs/Documentation.vue": [
		35036,
		36,
		327
	],
	"./docs/index": [
		47884,
		36,
		248
	],
	"./docs/index.js": [
		47884,
		36,
		248
	],
	"./exchange": [
		42870
	],
	"./exchange/": [
		42870
	],
	"./exchange/AddExchange": [
		67480
	],
	"./exchange/AddExchange.vue": [
		67480
	],
	"./exchange/Layout": [
		56663
	],
	"./exchange/Layout.vue": [
		56663
	],
	"./exchange/index": [
		42870
	],
	"./exchange/index.js": [
		42870
	],
	"./gap-backtest": [
		147
	],
	"./gap-backtest/": [
		147
	],
	"./gap-backtest/CorporateEvents": [
		21692
	],
	"./gap-backtest/CorporateEvents.vue": [
		21692
	],
	"./gap-backtest/DataQuality": [
		42370
	],
	"./gap-backtest/DataQuality.vue": [
		42370
	],
	"./gap-backtest/DayReview": [
		8318
	],
	"./gap-backtest/DayReview.vue": [
		8318
	],
	"./gap-backtest/DayReviewChart": [
		27564
	],
	"./gap-backtest/DayReviewChart.vue": [
		27564
	],
	"./gap-backtest/EquityCurveChart": [
		48031
	],
	"./gap-backtest/EquityCurveChart.vue": [
		48031
	],
	"./gap-backtest/GapBacktestShortlist": [
		29821
	],
	"./gap-backtest/GapBacktestShortlist.vue": [
		29821
	],
	"./gap-backtest/Layout": [
		19726
	],
	"./gap-backtest/Layout.vue": [
		19726
	],
	"./gap-backtest/LivePaperTrading": [
		13311
	],
	"./gap-backtest/LivePaperTrading.vue": [
		13311
	],
	"./gap-backtest/PaperTradingSettings": [
		32945
	],
	"./gap-backtest/PaperTradingSettings.vue": [
		32945
	],
	"./gap-backtest/ParamOptimizer": [
		43811
	],
	"./gap-backtest/ParamOptimizer.vue": [
		43811
	],
	"./gap-backtest/StockRankingTable": [
		81633
	],
	"./gap-backtest/StockRankingTable.vue": [
		81633
	],
	"./gap-backtest/StockUniverse": [
		76976
	],
	"./gap-backtest/StockUniverse.vue": [
		76976
	],
	"./gap-backtest/StrategyConfig": [
		66697
	],
	"./gap-backtest/StrategyConfig.vue": [
		66697
	],
	"./gap-backtest/StrategyLab": [
		84732
	],
	"./gap-backtest/StrategyLab.vue": [
		84732
	],
	"./gap-backtest/TradeSideChip": [
		81998
	],
	"./gap-backtest/TradeSideChip.vue": [
		81998
	],
	"./gap-backtest/TradeStatsTiles": [
		39128
	],
	"./gap-backtest/TradeStatsTiles.vue": [
		39128
	],
	"./gap-backtest/Watchlist": [
		36694
	],
	"./gap-backtest/Watchlist.vue": [
		36694
	],
	"./gap-backtest/index": [
		147
	],
	"./gap-backtest/index.js": [
		147
	],
	"./import_profile": [
		63224
	],
	"./import_profile/": [
		63224
	],
	"./import_profile/ImportGrid": [
		92281
	],
	"./import_profile/ImportGrid.vue": [
		92281
	],
	"./import_profile/Layout": [
		95507
	],
	"./import_profile/Layout.vue": [
		95507
	],
	"./import_profile/index": [
		63224
	],
	"./import_profile/index.js": [
		63224
	],
	"./index": [
		22578,
		729,
		815,
		954
	],
	"./index.js": [
		22578,
		729,
		815,
		954
	],
	"./investment_plan": [
		16296
	],
	"./investment_plan/": [
		16296
	],
	"./investment_plan/AddSummary": [
		86918
	],
	"./investment_plan/AddSummary.vue": [
		86918
	],
	"./investment_plan/Details": [
		78122
	],
	"./investment_plan/Details.vue": [
		78122
	],
	"./investment_plan/Layout": [
		66646
	],
	"./investment_plan/Layout.vue": [
		66646
	],
	"./investment_plan/Summary": [
		40538
	],
	"./investment_plan/Summary.vue": [
		40538
	],
	"./investment_plan/index": [
		16296
	],
	"./investment_plan/index.js": [
		16296
	],
	"./investment_plan/summary/Investment": [
		39242
	],
	"./investment_plan/summary/Investment.vue": [
		39242
	],
	"./investment_plan/summary/Investment_chart": [
		55081
	],
	"./investment_plan/summary/Investment_chart.vue": [
		55081
	],
	"./investment_plan/summary/Investment_type": [
		30599
	],
	"./investment_plan/summary/Investment_type.vue": [
		30599
	],
	"./investment_plan/summary/List": [
		52669
	],
	"./investment_plan/summary/List.vue": [
		52669
	],
	"./notifications": [
		91773
	],
	"./notifications/": [
		91773
	],
	"./notifications/Layout": [
		126
	],
	"./notifications/Layout.vue": [
		126
	],
	"./notifications/NotificationDetail": [
		17367
	],
	"./notifications/NotificationDetail.vue": [
		17367
	],
	"./notifications/index": [
		91773
	],
	"./notifications/index.js": [
		91773
	],
	"./order-log": [
		550
	],
	"./order-log/": [
		550
	],
	"./order-log/Layout": [
		91118
	],
	"./order-log/Layout.vue": [
		91118
	],
	"./order-log/OrderLog": [
		52309
	],
	"./order-log/OrderLog.vue": [
		52309
	],
	"./order-log/index": [
		550
	],
	"./order-log/index.js": [
		550
	],
	"./performance": [
		36267
	],
	"./performance/": [
		36267
	],
	"./performance/Layout": [
		40112
	],
	"./performance/Layout.vue": [
		40112
	],
	"./performance/Returns": [
		59199
	],
	"./performance/Returns.vue": [
		59199
	],
	"./performance/Summary": [
		40917
	],
	"./performance/Summary.vue": [
		40917
	],
	"./performance/index": [
		36267
	],
	"./performance/index.js": [
		36267
	],
	"./platform": [
		86180
	],
	"./platform/": [
		86180
	],
	"./platform/AddPlatform": [
		82345
	],
	"./platform/AddPlatform.vue": [
		82345
	],
	"./platform/Layout": [
		45796
	],
	"./platform/Layout.vue": [
		45796
	],
	"./platform/index": [
		86180
	],
	"./platform/index.js": [
		86180
	],
	"./scheduler": [
		52048
	],
	"./scheduler/": [
		52048
	],
	"./scheduler/Crons": [
		39498
	],
	"./scheduler/Crons.vue": [
		39498
	],
	"./scheduler/Layout": [
		57172
	],
	"./scheduler/Layout.vue": [
		57172
	],
	"./scheduler/crons/Action": [
		35627,
		627
	],
	"./scheduler/crons/Action.vue": [
		35627,
		627
	],
	"./scheduler/index": [
		52048
	],
	"./scheduler/index.js": [
		52048
	],
	"./sector": [
		80709
	],
	"./sector/": [
		80709
	],
	"./sector/AddSector": [
		30683
	],
	"./sector/AddSector.vue": [
		30683
	],
	"./sector/Layout": [
		89289
	],
	"./sector/Layout.vue": [
		89289
	],
	"./sector/Summary": [
		42560
	],
	"./sector/Summary.vue": [
		42560
	],
	"./sector/index": [
		80709
	],
	"./sector/index.js": [
		80709
	],
	"./stock": [
		50091
	],
	"./stock/": [
		50091
	],
	"./stock/AddStock": [
		91492
	],
	"./stock/AddStock.vue": [
		91492
	],
	"./stock/Dividend/AddDividend": [
		92863
	],
	"./stock/Dividend/AddDividend.vue": [
		92863
	],
	"./stock/Dividend/ImportDividend": [
		88944
	],
	"./stock/Dividend/ImportDividend.vue": [
		88944
	],
	"./stock/Dividend/Report": [
		8461
	],
	"./stock/Dividend/Report.vue": [
		8461
	],
	"./stock/Layout": [
		38898
	],
	"./stock/Layout.vue": [
		38898
	],
	"./stock/StockAnalysis": [
		14645
	],
	"./stock/StockAnalysis.vue": [
		14645
	],
	"./stock/StockList": [
		44002
	],
	"./stock/StockList.vue": [
		44002
	],
	"./stock/StockTransaction": [
		51142
	],
	"./stock/StockTransaction.vue": [
		51142
	],
	"./stock/ViewStock": [
		76646
	],
	"./stock/ViewStock.vue": [
		76646
	],
	"./stock/index": [
		50091
	],
	"./stock/index.js": [
		50091
	],
	"./stock/stockList/ProfitLossPer": [
		92972,
		972
	],
	"./stock/stockList/ProfitLossPer.vue": [
		92972,
		972
	],
	"./stock/stockList/StockId": [
		23107,
		107
	],
	"./stock/stockList/StockId.vue": [
		23107,
		107
	],
	"./stock/stockTransaction/StockId": [
		31088,
		88
	],
	"./stock/stockTransaction/StockId.vue": [
		31088,
		88
	],
	"./stock/view/chart/Summary": [
		31786
	],
	"./stock/view/chart/Summary.vue": [
		31786
	],
	"./stock/view/tracker/Call": [
		37295
	],
	"./stock/view/tracker/Call.vue": [
		37295
	],
	"./stock/view/tracker/CallRow": [
		63813
	],
	"./stock/view/tracker/CallRow.vue": [
		63813
	],
	"./tracker": [
		72717
	],
	"./tracker/": [
		72717
	],
	"./tracker/BuySell": [
		41034
	],
	"./tracker/BuySell.vue": [
		41034
	],
	"./tracker/Layout": [
		86061
	],
	"./tracker/Layout.vue": [
		86061
	],
	"./tracker/ThreadList": [
		97517
	],
	"./tracker/ThreadList.vue": [
		97517
	],
	"./tracker/buySell/CurrentPrice": [
		24614
	],
	"./tracker/buySell/CurrentPrice.vue": [
		24614
	],
	"./tracker/index": [
		72717
	],
	"./tracker/index.js": [
		72717
	],
	"./tracker/shreadList/Thread": [
		70053
	],
	"./tracker/shreadList/Thread.vue": [
		70053
	],
	"./trade": [
		70379
	],
	"./trade/": [
		70379
	],
	"./trade/Add": [
		36376
	],
	"./trade/Add.vue": [
		36376
	],
	"./trade/Layout": [
		16522
	],
	"./trade/Layout.vue": [
		16522
	],
	"./trade/TradeOrderDashboard": [
		89153
	],
	"./trade/TradeOrderDashboard.vue": [
		89153
	],
	"./trade/index": [
		70379
	],
	"./trade/index.js": [
		70379
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99555;
module.exports = webpackAsyncContext;